import { render, staticRenderFns } from "./EmissionPointAdd.vue?vue&type=template&id=6df586e6&scoped=true"
import script from "./EmissionPointAdd.vue?vue&type=script&lang=js"
export * from "./EmissionPointAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df586e6",
  null
  
)

export default component.exports